import { ISearchFilterStore } from './SearchFilter.interface';

export const searchFilterInitialState: ISearchFilterStore = {};
